import { TranslateLoader } from '@ngx-translate/core';
import { Observable, Observer } from 'rxjs';
export class TranslationLoader implements TranslateLoader {
    private _en: any;
    private _ru: any;
    private _lv: any;
    constructor() {
        this._en = require('../translations/en.json');
        this._ru = require('../translations/ru.json');
        this._lv = require('../translations/lv.json');
    }

    public extend(lang: string, translation: any) {
        Object.assign(this.getTranslationByLang(lang), translation);
    }

    public getTranslation(lang: string): Observable<any> {
        return Observable.create((observer: Observer<string>) => {
            observer.next(this.getTranslationByLang(lang));
            observer.complete();
        });
    }

    private getTranslationByLang(lang: string): any {
        switch (lang) {
            case 'en':
                return this._en;
            case 'ru':
                return this._ru;
            case 'lv':
                return this._lv;
            default:
                return this._en;
        }
    }
}




// WEBPACK FOOTER //
// ./src/app/services/translationLoader.ts